<template>
    <div class="form-group">
        <label
            :class="{
                'text-danger': errors && errors.length,
                'text-dark': !errors || !errors.length,
                required: required
            }"
            v-if="label"
        >
            <small v-if="labelSmall">{{ label }}</small>
            <template v-else>{{ label }}</template>
        </label>

        <div>
            <vue-check-input
                v-for="item in data"
                :key="`check-input-${dataValue(item)}`"
                :radio="radio"
                :checkValue="dataValue(item)"
                :label="dataText(item)"
                :value="inputValue(item)"
                v-on:input="input"
            />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueCheckInput from '@components/checkInput';

    export default Vue.extend({
        components: {
            VueCheckInput
        },
        props: {
            value: null,
            radio: Boolean,
            label: String,
            errors: Array,
            required: Boolean,
            labelSmall: {
                default: true,
                type: Boolean
            },
            data: {
                required: true,
                type: Array
            },
            dataValue: {
                default: (item) => item.id,
                type: Function
            },
            dataText: {
                default: (item) => item.text,
                type: Function
            }
        },
        watch: {
            value() {
                this.setValues();
            }
        },
        data() {
            return {
                checkedValues: null
            };
        },
        methods: {
            input($event) {
                if (this.radio) {
                    this.checkedValues = $event;
                    this.$emit('input', $event);
                } else {
                    this.checkedValues[$event] = !this.checkedValues[$event];
                    const checked = [];

                    Object.keys(this.checkedValues).map((v) => {
                        if (this.checkedValues[v]) {
                            checked.push(v);
                        }
                    });

                    this.$emit('input', checked);
                }
            },
            inputValue(item) {
                if (this.radio) {
                    return this.checkedValues;
                }

                return this.checkedValues[this.dataValue(item)] ? this.dataValue(item) : null;
            },
            setValues() {
                this.checkedValues = this.value;

                if (!this.radio) {
                    this.checkedValues = {};

                    this.data.forEach((item) => {
                        this.checkedValues[this.dataValue(item)] = this.value
                            ? this.value.includes(this.dataValue(item))
                            : false;
                    });
                }
            }
        },
        mounted() {
            this.setValues();
        }
    });
</script>
